import {Validators} from '@angular/forms';

import {AddressValidator, LatinDigitsValidator, OnlyLatinValidator, WhitespaceValidator} from '@spa/validators';

import {ComponentTypesEnum} from '../../../../app/shared/enums';
import {CountryAutocompleteControl, BaseControl} from '../../../../app/shared/classes';

export const CompanyAddressIdSelector = 'id';
export const CompanyAddressCountrySelector = 'country';
export const CompanyAddressCitySelector = 'city';
export const CompanyAddressStateSelector = 'state';
export const CompanyAddressPostalCodeSelector = 'postalCode';
export const CompanyAddressSelector = 'address';
export const CompanyAddressTypeSelector = 'addressType';

export const CompanyAddressControls = (): BaseControl[] => {
    return [
        new BaseControl({
            name: CompanyAddressIdSelector,
            value: null,
            placeholder: '',
            validators: [],
            componentType: ComponentTypesEnum.Text,
            hidden: true
        }),
        new BaseControl({
            name: CompanyAddressTypeSelector,
            value: '',
            placeholder: '',
            validators: [],
            componentType: ComponentTypesEnum.Text,
            hidden: true
        }),
        new CountryAutocompleteControl({
            name: CompanyAddressCountrySelector,
            value: null,
            placeholder: 'Country',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.CountryAutocomplete,
            floatingLabelNever: true,
            options: [],
            countries: [],
        }),
        new BaseControl({
            name: CompanyAddressCitySelector,
            value: '',
            placeholder: 'City',
            validators: [WhitespaceValidator(), OnlyLatinValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
        new BaseControl({
            name: CompanyAddressStateSelector,
            value: '',
            placeholder: 'State',
            validators: [WhitespaceValidator(), OnlyLatinValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
        new BaseControl({
            name: CompanyAddressPostalCodeSelector,
            value: '',
            placeholder: 'Postal code',
            validators: [WhitespaceValidator(), LatinDigitsValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
        new BaseControl({
            name: CompanyAddressSelector,
            value: '',
            placeholder: 'Address',
            validators: [WhitespaceValidator(), AddressValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        })
    ];
};
